import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Content } from "../../components/wrappers/Content";
import { Yachts } from "../Offers/EditOffer/Yachts";
import { useOffersStore } from "../../stores/offersStore";
import { useFetch } from "../../lib/useFetch";
import { Currency } from "../Currencies/model";
import { ActionsContext } from "../../lib/actions";

/**
 * Standalone fleet search (Phase 1, B1/B2): the offer builder's choose-yachts
 * stage, usable outside an offer. Same search, filters, enriched cards
 * (broker notes, chartered-before + history). "Add to the offer" starts a
 * new offer.
 */
export default function Fleet() {
  const navigate = useNavigate();
  const { setCurrencies } = useOffersStore();
  const { fetch } = useFetch();

  // YachtCard prices via the offers store's currency list; load it here since
  // we're outside EditOfferForm.
  useEffect(() => {
    fetch<{ data: Currency[] }>("/api/currencies").then((res) => setCurrencies(res.data ?? []));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // YachtsListing reads the offer currency from a form context; standalone we
  // pin EUR (display-only — adding a yacht routes into a real offer).
  const methods = useForm({ defaultValues: { description: { currency: "EUR" } } });

  return (
    <Content title="Fleet search">
      {/* The fleet filter modal's "Show yachts"/"Clear all" buttons emit via useEmit
          and YachtsFiltersForm listens via useSubscribe — both need an ActionsContext
          provider. In the offer builder that comes from WithActionBar; this standalone
          page has neither, so without this provider the emit/subscribe fall back to the
          no-op context and both buttons did nothing. */}
      <ActionsContext>
        <FormProvider {...methods}>
          <Yachts openChangeDetails={() => navigate("/offers/add")} />
        </FormProvider>
      </ActionsContext>
    </Content>
  );
}
